import { TimeoutError } from 'p-timeout'

export default class BridgeTimeoutError extends TimeoutError {
  constructor(message: string) {
    super(message)
  }
}
